const MuscleGroupActionTypes = {
  FETCH_MUSCLE_GROUPS: 'FETCH_MUSCLE_GROUPS',
  CHANGE_PRESSED_MUSCLE_GROUPS: 'CHANGE_PRESSED_MUSCLE_GROUPS',
  FIND_PRESSED_MUSCLE_GROUPS: 'FIND_PRESSED_MUSCLE_GROUPS',
};

export default MuscleGroupActionTypes;
